module.exports = __webpack_public_path__ + "static/media/mark-casual-3.1c76e410.jpg";